import React from 'react';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';

export default ({ local }) => {
  let status = 'Estado: Cerrado';

  if (local.abierto) {
    status = local.is24h ? 'Abierto las 24 horas' : 'Estado: Abierto';
  }

  const phoneNumber = (number) => {
     return "tel:+52" + number.toString();
  }

  return (
    <Container>
      <Name>{local.marca} - {local.name}</Name>
      <Address>{local.direccion}</Address>
      {
        local.telefono != "" &&
        <Phone> 
          Servicio a domicilio: 
            <Icon>
              <FontAwesomeIcon icon={faPhoneAlt} />
            </Icon>

            <a href={phoneNumber(local.telefono)}>
                {local.telefono}
            </a>
        </Phone>
      }
      <OpeningHours>
        Lunes a Viernes:
        {' '}
        {local.lv}
        <br />
        Sábado:
        {' '}
        {local.sa}
        <br />
        Domingo:
        {' '}
        {local.do}
      </OpeningHours>

      <StatusContainer open={local.abierto} is24h={local.is24h}>
        <Status>
          { status }
        </Status>
        {/* <Distance>
          {local.distance}
          {' '}
          kms
        </Distance> */}
      </StatusContainer>
      <ConsultorioContainer open={local.servConsultorio}>
        <Address> Consultorio </Address>

        <Services>
          Servicios:
          <br/>
          {
            local.pruebas.map((prueba, index) => ( prueba != '' && <Test class="item"> { prueba }</Test>))
          }
        </Services>
        <OpeningHours>
          Lunes a Viernes:
          {' '}
          {local.lvConsultorio}
          <br />
          Sábado:
          {' '}
          {local.saConsultorio}
          <br />
          Domingo:
          {' '}
          {(local.doConsultorio != '') ? local.doConsultorio : "Cerrado"}
        </OpeningHours>
              <StatusContainer open={local.consultorioStatus && local.doConsultorio != ''} >
        <Status>
          Estado : { local.consultorioStatus ? "Abierto" : "Cerrado" }
        </Status>
        {/* <Distance>
          {local.distance}
          {' '}
          kms
        </Distance> */}
      </StatusContainer>
      </ConsultorioContainer>

    </Container>
  );
};

const Container = styled.div``;

const Name = styled.div`
  ${tw`
    font-bold mr-4 text-lg
  `};
`;

const Address = styled.div`
  ${tw`
    font-bold mr-4
  `};
`;

const Phone = styled.div`
  ${tw`
    my-3
  `};

  a {
    font-weight: 600;
  }
`;

const Services = styled.div`
  ${tw`
    my-3
  `};
`;

const Test = styled.span`
  ${tw`
    my-3 
  `};

  &:not(:last-of-type):after {
  display: inline-block;
  white-space: pre;
  content: " - ";
  }

`;

const OpeningHours = styled.div`
  ${tw`
    my-3
  `};
`;


const ConsultorioContainer = styled.div`
  ${tw`
     py-2 
  `};

  ${(props) => !props.open && css`
    display : none;
  `}
`

const StatusContainer = styled.div`
  background-color: #000099;

  ${tw`
    flex justify-between text-white px-2 py-1 font-bold
  `};



  ${(props) => props.is24h && css`
    background-color: #FCD329;
    color: #00953B;
    font-weight: bold;
  `}
`;

const Icon = styled.div`
   margin-left: 0.5em;
   margin-right: 0.5em;
   display: inline-block;
`;

const Status = styled.div`
`;

const Distance = styled.div`
`;
